export default "__VITE_ASSET__BFzFKJW6__"